var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("transition", { attrs: { name: "component-fade", mode: "out-in" } }, [
        _vm.finalFilePath && !_vm.uploading
          ? _c("div", { key: "1", staticClass: "position-relative" }, [
              _c(
                "button",
                {
                  staticClass: "btn btn-danger btn-sm position-absolute",
                  staticStyle: { top: "10px", right: "10px" },
                  on: { click: _vm.deleteImage },
                },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm._f("translate")("Delete")) +
                      "\n      "
                  ),
                ]
              ),
              _vm._v(" "),
              _c("img", {
                staticClass: "img-fluid",
                staticStyle: { "max-height": "150px" },
                attrs: { src: _vm.img(_vm.finalFilePath), alt: "" },
              }),
            ])
          : _c("div", { key: "2" }, [
              _c(
                "div",
                {
                  staticClass:
                    "d-flex justify-content-center align-items-center border",
                  class: {
                    "bg-light": !_vm.hover,
                    "bg-white": _vm.hover,
                    "border-primary": _vm.hover,
                    pointer: !_vm.uploading,
                  },
                  staticStyle: { height: "100px" },
                  on: {
                    dragenter: function ($event) {
                      $event.stopPropagation()
                      $event.preventDefault()
                      return _vm.handleDrag.apply(null, arguments)
                    },
                    dragover: function ($event) {
                      $event.stopPropagation()
                      $event.preventDefault()
                      return _vm.handleDrag.apply(null, arguments)
                    },
                    dragleave: function ($event) {
                      $event.stopPropagation()
                      $event.preventDefault()
                      return _vm.handleDragEnd.apply(null, arguments)
                    },
                    dragend: function ($event) {
                      $event.stopPropagation()
                      $event.preventDefault()
                      return _vm.handleDragEnd.apply(null, arguments)
                    },
                    drop: function ($event) {
                      $event.stopPropagation()
                      $event.preventDefault()
                      return _vm.handleDrop.apply(null, arguments)
                    },
                    click: _vm.chooseFile,
                  },
                },
                [
                  _vm.uploading
                    ? _c("div", { staticClass: "w-75" }, [
                        _c("span", [
                          _vm._v(
                            _vm._s(_vm._f("translate")("Uploading")) + ":"
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "progress" }, [
                          _c("div", {
                            staticClass:
                              "progress-bar progress-bar-striped progress-bar-animated",
                            style: `width: ${_vm.status}%`,
                            attrs: {
                              role: "progressbar",
                              "aria-valuenow": _vm.status,
                              "aria-valuemin": "0",
                              "aria-valuemax": "100",
                            },
                          }),
                        ]),
                      ])
                    : _c("div", { staticClass: "text-center" }, [
                        _c("small", [
                          _c("b", [
                            _vm._v(_vm._s(_vm._f("translate")("Choose file"))),
                          ]),
                          _vm._v(" "),
                          _c("br"),
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm._f("translate")("or drag it here")) +
                              "\n          "
                          ),
                        ]),
                      ]),
                ]
              ),
              _vm._v(" "),
              !_vm.disableCompression
                ? _c("div", { staticClass: "form-check form-switch mt-2" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.compressUploadedImages,
                          expression: "compressUploadedImages",
                        },
                      ],
                      staticClass: "form-check-input",
                      attrs: {
                        type: "checkbox",
                        id: `compress-${_vm.id}`,
                        value: "1",
                      },
                      domProps: {
                        checked: Array.isArray(_vm.compressUploadedImages)
                          ? _vm._i(_vm.compressUploadedImages, "1") > -1
                          : _vm.compressUploadedImages,
                      },
                      on: {
                        change: function ($event) {
                          var $$a = _vm.compressUploadedImages,
                            $$el = $event.target,
                            $$c = $$el.checked ? true : false
                          if (Array.isArray($$a)) {
                            var $$v = "1",
                              $$i = _vm._i($$a, $$v)
                            if ($$el.checked) {
                              $$i < 0 &&
                                (_vm.compressUploadedImages = $$a.concat([$$v]))
                            } else {
                              $$i > -1 &&
                                (_vm.compressUploadedImages = $$a
                                  .slice(0, $$i)
                                  .concat($$a.slice($$i + 1)))
                            }
                          } else {
                            _vm.compressUploadedImages = $$c
                          }
                        },
                      },
                    }),
                    _vm._v(" "),
                    _c(
                      "label",
                      {
                        staticClass: "form-check-label",
                        attrs: { for: `compress-${_vm.id}` },
                      },
                      [
                        _c("small", [
                          _vm._v(_vm._s(_vm._f("translate")("Compress image"))),
                        ]),
                      ]
                    ),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c("input", {
                ref: "fileInput",
                staticClass: "d-none",
                attrs: { accept: "image/*", type: "file" },
                on: { change: _vm.chooseFileSubmit },
              }),
            ]),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }